import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRingingBellIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={18}
    fill="none"
    viewBox="0 0 17 18"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7.209 4.026a1.378 1.378 0 0 1 2.755 0 4.82 4.82 0 0 1 2.755 4.133v2.066a2.76 2.76 0 0 0 1.377 2.066H3.076a2.75 2.75 0 0 0 1.378-2.066V8.159a4.82 4.82 0 0 1 2.755-4.133M6.52 12.297v.689a2.066 2.066 0 0 0 4.132 0v-.69M14.784 5.215a7.6 7.6 0 0 0-1.925-2.567M2.387 5.215A7.6 7.6 0 0 1 4.31 2.648"
    />
  </svg>
);
export default SvgRingingBellIcon;
